<template>
  <div>
    <div class="transition duration-150 w-7 h-7">
      <div v-if="!concluded" class="h-full w-full">
        <svg class="w-full h-full" viewBox="0 0 100 100">
          <circle
            class="text-gray-400 stroke-current"
            stroke-width="10"
            cx="50"
            cy="50"
            :r="radius"
            fill="transparent"
          ></circle>
          <circle
            class="text-h-success-500 progress-ring__circle stroke-current"
            stroke-width="10"
            stroke-linecap="round"
            cx="50"
            cy="50"
            :r="radius"
            fill="transparent"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="offset"
          ></circle>
        </svg>
      </div>
      <div v-if="concluded" :class="`w-full h-full`">
        <v-icon
          name="hi-solid-check-circle"
          class="text-green-600 w-full h-full"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "ProgressCircleMaterial",
  props: {
    progress: {
      type: Number,
      required: true,
    },
    concluded: {
      type: Boolean,
      required: true,
    },
    size: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    radius(): number {
      return this.size / 2;
    },
    circumference(): number {
      return 2 * Math.PI * this.radius;
    },
    offset(): number {
      return this.circumference - (this.circumference * this.progress) / 100;
    },
  },
});
</script>
